/**
 * Madera Verde Shop - Global Scripts
 * 
 * General utility scripts for the theme.
 * Specialized logic (like the hero scroll) is loaded within specific sections.
 */

console.log('Madera Verde Shop Theme Loaded');

// Example: Debounce function for potential future use (resize events etc)
function debounce(fn, wait) {
    let t;
    return (...args) => {
        clearTimeout(t);
        t = setTimeout(() => fn.apply(this, args), wait);
    };
}
